import * as React from 'react'
import { SideDrawerForm } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import { Name } from './Name'
import { Description } from './Description'
import { useData, useHandlers } from './hooks'
import { useFormikContext } from 'formik'
import type { ActivityType } from '../../../typings'

export function FormFields() {
  const { submitForm } = useFormikContext<ActivityType>()
  const { handleCancelClick } = useHandlers()
  const { disableSave } = useData()

  return (
    <SideDrawerForm
      onSave={submitForm}
      onCancel={handleCancelClick}
      disableSave={disableSave}
    >
      <Stack p={2}>
        <Name />
        <Description />
      </Stack>
    </SideDrawerForm>
  )
}
